<app-header></app-header>
<router-outlet #outlet="outlet"></router-outlet>
<app-footer></app-footer>
<app-navbar></app-navbar>
<app-cookies-panel></app-cookies-panel>